import { useEffect, useState, FunctionComponent } from 'react'

import AccordionContainer from 'components/accordion/AccordionContainer'
import { TopLevelAccordionContainerProps } from 'redux/containers/components/accordion/TopLevelAccordionContainer'

const TopLevelAccordion: FunctionComponent<TopLevelAccordionProps> = ({
  aol,
  group,
  eventCategory,
  highlight,
  flavourColor,
  cxNames,
  expandedNodeId,
  showAllS1 = false
}) => {
  if (typeof group === 'number') { // theoretically unreachable
    return null
  }
  const [nodes, setNodes] = useState(group)

  useEffect(() => {
    setNodes(expandedNodeId !== null && expandedNodeId !== undefined && expandedNodeId !== '' && Array.isArray(group) ? group.filter((node: { id: string }) => node.id === expandedNodeId) : group)
  }, [expandedNodeId, setNodes, group])

  return (
    <AccordionContainer
      key='accordion'
      {...{ aol, eventCategory, highlight, flavourColor, cxNames, showAllS1 }}
      group={showAllS1 ? group : nodes}
    />
  )
}

interface TopLevelAccordionProps extends TopLevelAccordionContainerProps {
  aol: string | string[]
  flavourColor: string | null
  cxNames: any
  showAllS1: boolean
}

export default TopLevelAccordion
